import * as React from "react";
import { COLORS } from "../../../constants";

interface IFormDisplay {
  title: string;
  value: string;
  highlight?: boolean;
}

class FormDisplay extends React.Component<IFormDisplay> {
  public render() {
    const { highlight, title, value } = this.props;
    return (
      <div className="field">
        <label style={styles.headerTitleStyle}>{title}</label>
        <span style={highlight ? styles.highlightStyle : undefined}>{value}</span>
      </div>
    );
  }
}

const styles = {
  headerTitleStyle: {
    color: "rgba(0,0,0,0.6)",
  },
  highlightStyle: {
    backgroundColor: COLORS.lightYellow,
    padding: 4,
  },
};
export default FormDisplay;
